
































































import { CatalogVue } from "fs-pb-vue2/vueModels/catalog/CatalogVue";
import { CatalogData } from "fs-pb-vue2/data/catalogData";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import Preloader from "@/components/app/Preloader.vue";

@Component({
  components: { BackLink, Preloader }
})
export default class Transfers extends CatalogVue {
  get transfersCatalog(): CatalogData {
    return this.catalogStore.catalog.Childrens.find((cat: CatalogData) => cat.Caption === 'Переводы');
  }
}
